export const formatSecondsToMMSS = (totalSeconds:number) => {
  const rounded = Math.round(totalSeconds);
  const minutes = Math.floor(rounded / 60);
  const secs = rounded % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(secs).padStart(2, '0');
  return `${mm}:${ss}`;
}